import {provideRouter, Routes, withInMemoryScrolling, withRouterConfig} from '@angular/router';
import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';

export function provideAviaryRouter(routes: Routes): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideRouter(routes,
      withRouterConfig({onSameUrlNavigation: 'reload'}),  // (*) See commentary below.
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'})) // (**) See commentary below.
  ]);
}

/*
  (*) {onSameUrlNavigation: 'reload'} is for search/list pages.  It allows us to load a '*_HOME' page without automatically searching, and then to reload the
  same page if the user clicks the search button without changing anything else (thus, an "everything" search).

  ALWAYS reloading on same-URL navigation is heavy-handed, but in Angular v14, it's all or nothing.  We'll be able to control this per route in v15.

  See https://blog.ninja-squad.com/2023/01/11/what-is-new-angular-15.1/ (the second paragraph under "Router").


  (**) {scrollPositionRestoration: 'enabled'} makes In-App navigation (clicking a button/link or route changes from our events) scroll to the top of the
   page, while saving and re-applying the user's scroll positions when using the browser's back/forward navigation buttons.

   Important: This is required for our ScrollRestorationService to work.  It keeps track of the scroll position of the page before a Router navigation
    event, and ScrollRestorationService restores that scroll position once data for the page has been loaded.
*/
